import { css } from "@emotion/react";
import { FrjTagGrid } from "../pages/FrjArticles/FrjTagGrid";

export const FrjLatestPosts = ({ className }: { className?: string }) => {
  return (
    <div
      className={className}
      css={css`
        position: relative;
      `}
    >
      <FrjTagGrid
        css={css`
          max-height: 450px;
          overflow: hidden;
        `}
      />
      <div
        css={css`
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 140px;
          background: linear-gradient(to bottom, transparent, white);
          pointer-events: none;
        `}
      />
    </div>
  );
};
